'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002eintelacloud$002e$002dMain from "./io.intela.sites.intelacloud.-Main.js";
var $p;
$j_io$002eintela$002esites$002eintelacloud$002e$002dMain.$s_Lio_intela_sites_intelacloud_Main__main__AT__V(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_T.r().C)([]));
//# sourceMappingURL=main.js.map
